var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQualifiedEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_86)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1444 27.3481C7.6904 28.0508 0.272 29.933 0.0247205 36.433C-0.222559 42.9079 1.36003 40.9755 18.1751 40.9755C31.0831 40.9755 31.8496 42.5817 31.8249 37.5373C31.8249 35.6801 31.5529 33.8481 30.7616 32.6434C28.4372 29.0546 20.0544 26.6956 14.1444 27.3481ZM32.7151 27.4735C33.5806 29.8326 35.2127 29.7322 35.8556 32.8191C36.9189 37.8384 34.1246 40.4986 38.4026 40.9755L47.2799 41.0508C51.4342 40.7998 51.6568 31.5643 42.087 28.5276C39.9357 27.85 34.8665 26.3944 32.7151 27.4735ZM31.6024 9.37895C23.1701 12.9928 27.9179 24.3867 35.9298 22.3037C44.5351 20.0701 40.455 5.58937 31.6024 9.37895ZM13.5015 9.40404C21.8595 6.01601 26.2859 18.4639 18.5213 22.0025C11.0781 25.3905 4.27794 13.1434 13.5015 9.40404Z",
    fill: "#8B0E01"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualifiedEmployee);
export default __webpack_public_path__ + "static/media/QualifiedEmployee.7d9f3bc6f7c2fe01c364d520aff5ded4.svg";
export { ForwardRef as ReactComponent };